export enum LocationType {
    HOSPITAL = 'Hospital',
    FIRST_AID = 'First Aid'
}

export class OrgLocation {
    id?: string;
    location_name: string;
    location_type?: LocationType;
    org_id: string;
    org_name: string;
    email?: string;
    phone?: string;
    contact_name?: string;
    timezone?: any;
    address_1?: any;
    address_2?: any;
    city?: any;
    state?: any;
    zipcode?: any;
    country?: any;
    credit_allotment?: number;
    extra_credit?: number;
    tier_1?: number;
    tier_2?: number;
    tier_3?: number;
    tier_2_threshold?: number;
    tier_3_threshold?: number;
    monthly_fee?: number;
}